// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"776":"8d948c78","907":"f54dfbe0"}[chunkId] + ".chunk.js";
};